module.exports = __webpack_public_path__ + "static/calathea-lancifolia-f56c4cedbc5ad78a998344479b068765.svg";